import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { adminGetSatilikArac } from "../../features/admin3/admin3Slice";
import AdminSatilikAraclarContainer from "../adminContainers/adminIlanlar/AdminSatilikAraclarContainer";
import Pagination from "../shared/Pagination";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .titles {
      width: 100%;
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(10, 1fr); 
      align-items: center;
      padding-inline: 10px;
      gap: 15px;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
      text-align: center;
      color: ${({ theme }) => theme.mainTextColor};
    }
  }
`;

const titles = ["Araç Türü", "Model Yılı", "Km", "Fiyat", "Açıklama", "Fotoğraflar", "İlan Bitiş", "Onay","Durum","Satıldı Mı?"]


const SatilikAraclarAdmin = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const {adminSatilikAracList, adminSatilikAracCount} = useSelector((state) => state.admin3)
  const dispatch = useDispatch()

    const [currentPage, setCurrentPage] = useState(1);
  
    const itemsPerPage = 10;
  
    const totalPages = Math.ceil(adminSatilikAracCount / itemsPerPage);

  useEffect(() => {
    dispatch(adminGetSatilikArac({page: currentPage}))
  }, [currentPage])

  return (
    <Container theme={theme}>
      <div className="container">
        <div className="titles">
          {titles.map((item) => (
              <p>{item}</p>
          ))}
        </div>

        {adminSatilikAracList?.map((item) => (
          <AdminSatilikAraclarContainer data={item} />
        ))}
        {(adminSatilikAracList && adminSatilikAracList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </Container>
  );
};

export default SatilikAraclarAdmin;
